import styles from './APIKeys.module.scss';
import { useSession, useTeamInfo } from 'src/hooks';
import { CreateAPIKey } from 'src/pages/ManageAccountPage/components/APIKeys/components/CreateAPIKey';
import { AppRoutes } from 'src/types';
import { useNavigate } from 'react-router-dom';
import { ArrowSquareOut } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { API_DOC_LINK } from 'src/constants/externalLinks';
import { ApiKeysTable } from './components/ApiKeysTable';
import { ContactOwnerButton } from './components/ContactOwnerButton';

import { Button } from 'src/v2/commonComponents/Button';
import { AddOnContainer } from 'src/pages/AddOnPage/components/AddOnContainer';

export const APIKeys = () => {
  const { isOpenTier } = useSession();
  const { isMember, isAdmin, isTeamInfoLoading } = useTeamInfo();
  const navigate = useNavigate();

  const isOwnerOfSubscription = !(isMember || isAdmin) && !isTeamInfoLoading;

  const handleSignUpClick = () => {
    navigate(AppRoutes.SIGN_UP);
  };

  return (
    <AddOnContainer>
      <div className={styles.root}>
        <div className={styles.headerRow}>
          <div className={styles.headerLeftSide}>
            <h4 className={styles.headerTitle}>
              {!isOwnerOfSubscription
                ? 'Request API key details'
                : 'Manage your API keys'}
            </h4>
            {isOpenTier ? (
              <span className={styles.headerDescription}>
                Generate API keys to integrate Ninja APIs into your
                applications. Keep them private and safe.
              </span>
            ) : (
              <>
                {!isOwnerOfSubscription ? (
                  <span className={styles.headerDescription}>
                    Contact your workspace owner to obtain API key access.
                  </span>
                ) : (
                  <span className={styles.headerDescription}>
                    Generate, and manage API keys for secure access to Ninja.{' '}
                    <br />
                    Keep them private and safe.
                  </span>
                )}
              </>
            )}
            <div className={styles.buttonsWrapper}>
              <Button
                as="a"
                href={API_DOC_LINK}
                target="_blank"
                rel="noopener noreferrer"
                color="link"
                className={styles.link}
              >
                <span>Go to API Documentation</span>
                <ArrowSquareOut size={SVG_SIZE_M} />
              </Button>
            </div>
          </div>
          {isOpenTier ? (
            <Button onClick={handleSignUpClick}>Sign up</Button>
          ) : (
            <>
              {isOwnerOfSubscription ? (
                <CreateAPIKey />
              ) : (
                <ContactOwnerButton />
              )}
            </>
          )}
        </div>

        {isOwnerOfSubscription && <ApiKeysTable />}
      </div>
    </AddOnContainer>
  );
};
